import { useTranslation } from '@sib/i18n';
import { Button, Dialog, DialogContent, DialogTitle } from '@sib/ui';
import { useDialog } from '../hooks';

interface LogoutDialogProps
  extends Omit<ReturnType<typeof useDialog>, 'handleOpen'> {
  onLogout: () => void;
}

export const LogoutDialog = ({
  onLogout,
  isOpen,
  handleClose,
}: LogoutDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="flex flex-col items-center">
        <DialogTitle className="text-xl">{t('logout.title')}</DialogTitle>
        <p className="text-center text-sm">
          {t('components.defaultLayout.logOutConfirmation')}
        </p>
        <div className="mt-4 flex w-full justify-center gap-2">
          <Button
            onClick={() => {
              onLogout();
              handleClose();
            }}
            className="w-full max-w-48"
          >
            {t('logout.title')}
          </Button>
          <Button
            onClick={handleClose}
            variant="outline"
            className="w-full max-w-48"
          >
            {t('cancel')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
